import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import { PlanList } from '../../modal';

import * as ActionPlanList from './action';

@Injectable()
export class PlanListEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  loadAction$ = createEffect(() => this.actions$
    .pipe(
      ofType<ActionPlanList.PostPlanListRequest>(ActionPlanList.POST_PlanList),
      map(action => {return action.payload as any}),
      
    ));
  private handleError(error) {
    return of(new ActionPlanList.Error(error));
  }
}
